module.exports = __webpack_public_path__ + "img/17_newModelWorker_ysh.992a20ad.png";